import styled from 'styled-components';
import { theme } from '../../../theme';
const defaultDensity = 'base';
export const TableGrid = styled.table.withConfig({ displayName: "vui--TableGrid", componentId: "vui--7usb8e" }) `min-width:100%;width:max-content;display:grid;& thead,& tbody,& tfoot{display:contents;}--density:${theme.sizes[defaultDensity]};&& tr:hover td{background-color:#f2f8fc;}${({ css }) => css}`;
//# sourceMappingURL=TableGrid.js.map